(function () {
  function applyBodyLangClass() {
    if (!document.body) return;

    var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var normalized = htmlLang.replace(/[^a-z0-9-]/g, '').trim();
    var langToken = normalized.split('-')[0];
    if (!langToken) return;

    Array.from(document.body.classList)
      .filter(function (className) {
        return className.indexOf('lang-') === 0;
      })
      .forEach(function (className) {
        document.body.classList.remove(className);
      });

    document.body.classList.add('lang-' + langToken);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBodyLangClass);
  } else {
    applyBodyLangClass();
  }

  var langObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      if (mutations[i].attributeName === 'lang') {
        applyBodyLangClass();
        break;
      }
    }
  });

  langObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['lang'],
  });
})();
